"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ClickOutSideHolder = _interopRequireDefault(require("../ClickOutSideHolder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ComboBoxMultipleCheckbox = /*#__PURE__*/function (_Component) {
  _inherits(ComboBoxMultipleCheckbox, _Component);

  var _super = _createSuper(ComboBoxMultipleCheckbox);

  function ComboBoxMultipleCheckbox() {
    var _this;

    _classCallCheck(this, ComboBoxMultipleCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showOptions: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (!prevState.showOptions && _this.state.showOptions) {
        var select = document.querySelector('.optionsWrapper');
        if (select && select.scrollIntoView) select.scrollIntoView(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getLabel", function (value) {
      var options = _this.props.options;
      var option = options.find(function (option) {
        return option.value === value;
      });
      return option && option.label;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event, option) {
      var input = _this.props.input;

      var newValue = _toConsumableArray(input.value);

      if (event.target.checked) {
        newValue.push(option);
      } else {
        newValue.splice(newValue.indexOf(option), 1);
      }

      _this.setState({
        value: newValue
      });

      return input.onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOptions", function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({
          showOptions: !_this.state.showOptions
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxGroup", function () {
      var _this$props = _this.props,
          options = _this$props.options,
          input = _this$props.input,
          disabled = _this$props.disabled;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "optionsWrapper"
      }, options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "checkbox",
          key: index
        }, /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: option.value
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          name: "".concat(input.label, "[").concat(index, "]"),
          id: option.value,
          checked: input.value.indexOf(option.value) !== -1,
          onChange: function onChange(event) {
            return _this.handleChange(event, option.value);
          },
          disabled: disabled
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "checkbox-text"
        }, option.label)));
      }));
    });

    return _this;
  }

  _createClass(ComboBoxMultipleCheckbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var meta = this.props.meta;
      var wrapperClassName = (0, _classnames["default"])('input-element comboBox-multi-checkbox', {
        isOpen: this.state.showOptions
      });
      var buttonClassName = (0, _classnames["default"])('input-field', {
        'input-field__error': meta && meta.touched && meta.error
      });
      return /*#__PURE__*/_react["default"].createElement(_ClickOutSideHolder["default"], {
        className: wrapperClassName,
        onClickOutside: function onClickOutside() {
          return _this2.setState({
            showOptions: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: buttonClassName,
        onClick: this.toggleOptions,
        type: "button"
      }, this.props.input.value ? this.props.input.value.map(function (item, index, arr) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index,
          className: "input-value"
        }, _this2.getLabel(item), arr.length > 1 && index !== arr.length - 1 && ', ', ' ');
      }) : this.props.placeholder), this.state.showOptions && this.renderCheckboxGroup());
    }
  }]);

  return ComboBoxMultipleCheckbox;
}(_react.Component);

ComboBoxMultipleCheckbox.displayName = 'ComboBoxMultipleCheckbox';
ComboBoxMultipleCheckbox.propTypes = {
  options: _propTypes["default"].array.isRequired,
  input: _propTypes["default"].object.isRequired,
  placeholder: _propTypes["default"].string,
  meta: _propTypes["default"].shape({
    error: _propTypes["default"].string,
    label: _propTypes["default"].string,
    touched: _propTypes["default"].bool
  }).isRequired
};
var _default = ComboBoxMultipleCheckbox;
exports["default"] = _default;